/**
 * The one drawing of a die: the chat's tray, the prompt rows under the chat, and
 * every roll field draw it from here, so shape and colour cannot drift apart.
 * d4 triangle, d6 square, d8 diamond, d10 and d100 kite, d12 pentagon, d20
 * icosahedron outline. Each die keeps its own colour token (text-die-dN), and
 * the stroke is currentColor so a caller that sets a colour still wins.
 */
const SHAPES = {
    4: { path: 'M12 2 L22 20 L2 20 Z', hue: 'text-die-d4' },
    6: { path: 'M3 3 H21 V21 H3 Z', hue: 'text-die-d6' },
    8: { path: 'M12 2 L21 12 L12 22 L3 12 Z', hue: 'text-die-d8' },
    10: { path: 'M12 2 L21 9 L18 21 L6 21 L3 9 Z', hue: 'text-die-d10' },
    12: { path: 'M12 2 L21 8 L18 20 L6 20 L3 8 Z', hue: 'text-die-d12' },
    20: { path: 'M12 2 L20 7 L20 17 L12 22 L4 17 L4 7 Z', hue: 'text-die-d20' },
    100: { path: 'M12 2 L21 9 L18 21 L6 21 L3 9 Z', hue: 'text-die-d100' },
};

/** The die a rolled expression is drawn as: its largest, d6 when it names none. */
export const esDieOf = ( pText, pFallback = 6 ) => {
    const aSides = [ ...String( pText ?? '' ).matchAll( /\d*\s*d\s*(\d+)/gi ) ]
        .map( ( pMatch ) => parseInt( pMatch[ 1 ], 10 ) );
    return aSides.length === 0 ? pFallback : Math.max( ...aSides );
};

export function EsDieIcon( { sides = 20, className = 'size-6', colored = true, 'data-testid': dataTestId } ) {
    const aShape = SHAPES[ sides ] ?? SHAPES[ sides > 20 ? 100 : 20 ];

    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" data-testid={ dataTestId }
             className={ ( className + ' ' + ( colored ? aShape.hue : '' ) ).trim() }
             data-die={ sides } fill="none" stroke="currentColor" strokeWidth="1.5"
             strokeLinejoin="round" strokeLinecap="round">
            <path d={ aShape.path } />
        </svg>
    );
}
